// src/components/i18n/T.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';

type TProps = {
  fr: string;
  en: string;
};

const T: React.FC<TProps> = ({ fr, en }) => {
  const { i18n } = useTranslation();
  const language = i18n.language || 'fr';
  return <>{language.toLowerCase().startsWith('en') ? en : fr}</>;
};

export default T;
